var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VAutocomplete',_vm._g({attrs:{"outlined":"","value":_vm.value,"items":_vm.subSections,"rules":_vm.rules,"disabled":_vm.disabled,"loading":_vm.loading,"item-text":"sub_section","item-value":"id","label":"Sub Section","return-object":"","clearable":""}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }